<template>
  <div class="subModal">
    <form @submit.prevent="submitFile" enctype="multipart/form-data">
      <div class="preview" v-if="preview" :style="{ backgroundImage: `url(${preview})` }"></div>
      <input type="file" name="alterar" accept="image/*" ref="fileInput" @change="onFileChange">
      <button>Confirmar</button>
    </form>
  </div>
</template>

<script setup>


import { ref } from 'vue'

const emits = defineEmits(['textAlerta'])

const fileInput = ref()
const preview = ref('')

function onFileChange() {
  const file = fileInput.value?.files?.[0]
  preview.value = file ? URL.createObjectURL(file) : ''
}

async function submitFile() {
  const file = fileInput.value?.files?.[0]
  if (!file) {
    emits('textAlerta', 'Escolha uma imagem')
    return
  }

  const form = new FormData()
  form.append('photo', file)

  const res = await fetch('/api/account/avatar', {
    method: 'POST',
    credentials: 'include',
    body: form,
  })
  const data = await res.json().catch(() => ({}))
  emits('textAlerta', data.message ?? (res.ok ? 'Avatar atualizado!' : 'Erro ao atualizar avatar'))
}

</script>

<style scoped>
.preview {
  width: 72px;
  height: 72px;
  border-radius: 14px;
  background-size: cover;
  background-position: center;
  margin: 0 auto 10px auto;
}
</style>
